import { AND, AND_OPERATOR, OR_OPERATOR } from '../constants';

const getElasticsearchOperator = ({ operator }) => (operator === AND ? AND_OPERATOR : OR_OPERATOR);

export default getElasticsearchOperator;
